export default {
  resellerPayments: []
}
